var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$root.preview.inIframe === false)?_c('div',{staticClass:"drag",style:({top: _vm.top + 'px'}),on:{"touchstart":_vm.handleStart,"mousedown":_vm.handleStart,"touchmove":_vm.handleMove,"mousemove":_vm.handleMove,"mouseup":_vm.handleEnd,"touchend":_vm.handleEnd}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }